import Modern from './Modern/Modern';
import Compact from './Compact/Compact';
import Parchment from './Parchment/Parchment';
import Plaque from './Plaque/Plaque';
import Royal from './Royal/Royal';
import Classic from './Classic/Classic';
import Tiles from './Tiles/Tiles';
import Sidebar from './Sidebar/Sidebar';
import Ledger from './Ledger/Ledger';
import Banner from './Banner/Banner';
import Mosaic from './Mosaic/Mosaic';

export default { Modern, Compact, Parchment, Plaque, Royal, Classic, Tiles, Sidebar, Ledger, Banner, Mosaic };
